@if (showInfo()) {
  <mat-card
    appearance="outlined"
    class="dashboard-card info"
    [ngClass]="classToApply()">
    @if (data?.writtenAt) {
      <div class="dashboard-updated-chip">
        <fa-icon [icon]="['far', 'clock']"></fa-icon>
        {{
          data.writtenAt
            | datex: 'DD.MM.YY HH:mm' : undefined : languageService.langSignal()
        }}
      </div>
    }

    @let textParagraphsValue = textParagraphs();
    <mat-card-header>
      <!--<div class="icon-background"></div>-->
      <mat-card-title>{{ textParagraphsValue[0] }}</mat-card-title>
      <mat-card-subtitle>{{ textParagraphsValue[1] }}</mat-card-subtitle>
      <fa-icon
        class="main-icon"
        mat-card-avatar
        [icon]="iconToUse()"
        size="2x"></fa-icon>
      <button
        mat-icon-button
        style="position: absolute; top: 5px; right: 5px"
        (click)="onCloseInfo()">
        <fa-icon [icon]="['far', 'times']"></fa-icon>
      </button>
    </mat-card-header>
    <mat-card-content>
      @for (paragraph of textParagraphsValue; track $index; let i = $index) {
        <!--
          @if(i > 1 && paragraph !== '') {
            <ul>
                <li>{{ paragraph }}</li>
              </ul>
          }
          -->
        @if (i > 1 && paragraph !== '') {
          <p>
            {{ paragraph }}
          </p>
        }
        <!--
          @if(i > 1 && paragraph !== '') {
            <p>{{ paragraph }}</p>
          }
          -->
      }
    </mat-card-content>
  </mat-card>
}
